import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
   Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'hash',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('../pages/home')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../pages/login')
    },
    {
      path: '/knowledge-base',
      name: 'knowledge-base',
      component: () => import('../pages/agricultural-knowledge-base/home'),
      children:[
        {
          path: '/knowledge-list/:type',
          name: 'knowledge-list',
          component: () => import('../pages/agricultural-knowledge-base/knowledge-list'),
        },
        {
          path: '/knowledge-info/:id',
          name: 'knowledge-info',
          component: () => import('../pages/agricultural-knowledge-base/knowledge-info'),
        }
      ]
    },
    {
      path: '/experience',
      name: 'experience',
      component: () => import('../pages/planting-experience/home'),
      children:[
        {
          path: '/experience-list/:type',
          name: 'experience-list',
          component: () => import('../pages/planting-experience/experience-list'),
        },
        {
          path: '/experience-info/:id',
          name: 'experience-info',
          component: () => import('../pages/planting-experience/experience-info'),
        }
      ]
    },
    {
      path: '/expert-home',
      name: 'expert-home',
      component: () => import('../pages/expert-database/home'),
      children:[
        {
          path: '/expert-list/:id',
          name: 'expert-list',
          component: () => import('../pages/expert-database/expert-list'),
        },
        {
          path: '/expert-info/:id',
          name: 'expert-info',
          component: () => import('../pages/expert-database/expert-info'),
        },
        {
          path: '/online-question/:id',
          name: 'online-question',
          component: () => import('../pages/expert-database/online-question'),

        }
      ]
    },
    {
      path: '/question-home',
      name: 'question-home',
      component: () => import('../pages/knowledge-question/home'),
      children:[
        {
          path: '/question-list',
          name: 'question-list',
          component: () => import('../pages/knowledge-question/question-list'),
        },
        {
          path: '/question-info/:id',
          name: 'question-info',
          component: () => import('../pages/knowledge-question/question-info'),
        },
        {
          path: '/knowledge-question',
          name: 'knowledge-question',
          component: () => import('../pages/knowledge-question/online-question'),
        }
      ]
    },
    {
      path: '/knowledge-map',
      name: 'knowledge-map',
      component: () => import('../pages/knowledge-map'),
    },
    {
      path: '/system-info',
      name: 'system-info',
      component: () => import('../pages/personal-center/system-info'),
    },
    {
      path: '/share-experience',
      name: 'share-experience',
      component: () => import('../pages/personal-center/share-experience'),
    },
    {
      path: '/experience-detail/:id',
      name: 'experience-detail',
      component: () => import('../pages/personal-center/experience-detail'),
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js